import { render, staticRenderFns } from "./openAddRework.vue?vue&type=template&id=348bdf38&scoped=true&"
import script from "./openAddRework.vue?vue&type=script&lang=js&"
export * from "./openAddRework.vue?vue&type=script&lang=js&"
import style0 from "./openAddRework.vue?vue&type=style&index=0&id=348bdf38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348bdf38",
  null
  
)

export default component.exports